import React, { useState, Fragment } from "react";
import { useQueryClient } from 'react-query';
import moment from "moment";

import { usePermitFlightDates } from "../../../services/permits";
import {Icon, List, ListItemText} from "@material-ui/core";
import {DateRangeIcon} from "@material-ui/pickers/_shared/icons/DateRangeIcon";

const PermitDatesTooltip = (props) => {
  const permitUuid = props.permitUuid;
  const displayMode = props.displayMode;
  const tooltipSuffix = props.suffix || "";

  const [load, setLoad] = useState("WAIT");
  const queryClient = useQueryClient();
  //pass a dummy key so hits to cache will return dummy record until rendering tooltip
  const permitFlightDates = usePermitFlightDates({ queryClient, extraKeys: [permitUuid]});

  let toolTipText = "Retrieving info...";

  if (permitFlightDates.error) {
    toolTipText = "...";
  }

  if (permitFlightDates.data) {
    const rows = permitFlightDates.data;
    if (rows) {
      toolTipText = (
        <Fragment>
          {displayMode === "LIST"
            ?
              <List>
                {
                  rows.map((row, i) => {
                    //return((i > 0 ? ", " : "") + moment(row.flightDateUTC).format("DD MMM YYYY"));
                    return(<ListItemText primary={moment(row.flightDateUTC).format("DD MMM YYYY")} />)
                  })
                }
              </List>
            :
              <div style={{display: "flex", verticalAlign: "middle"}}>
                <div style={{display: "flex", verticalAlign: "middle"}}>
                  <DateRangeIcon fontSize={"small"} color={"action"}/>
                </div>
                <span>
                  {
                    rows.map((row, i) => {
                      return ((i > 0 ? "," : "") + moment(row.flightDateUTC).format("DD"));
                    })
                  }
                </span>
              </div>
          }
          <span>{tooltipSuffix}</span>
        </Fragment>
      );
    } else {
      toolTipText = "";
    }
  };

  return (
    <span>{toolTipText}</span>
  );
}

export default PermitDatesTooltip;